const $             = require('jquery');
const evtbus        = require('../evtbus');
const status        = require('../util/status');
const asset         = require('../util/asset');
const offline_modal = require('../modals/offline_modal');
const sidepanel     = require('../ctrl/sidepanel');
const Pagination    = require('../ctrl/pagination');

const fa = {
  fileDownload: require('@fortawesome/pro-light-svg-icons/faFileDownload').definition
};

const api = {};
const version = '7.14.3';
const vjs = {
  script: `https://unpkg.com/video.js@${version}/dist/video.min.js`,
  style: `https://unpkg.com/video.js@${version}/dist/video-js.min.css`
};

let elem = null;
let player = null;
let pagination = null;

function init() {
  if (init.promise) {
    return init.promise;
  }
  return init.promise = Promise.all([
    asset.script(vjs.script),
    asset.style(vjs.style)
  ]);
}

function createElem(video) {
  return $(`
    <div class="video-overlay">
      <div class="backdrop"></div>
      ${playerHtml(video)}
    </div>
  `);
}

function playerHtml(video) {
  return `
    <video id="player" class="video-js vjs-default-skin" controls>
      <source src="${video.url}" type="video/mp4">
    </video>`;
}

function videoDetails(video) {
  return $(`
    <div class="video-details">
      <h2>Detailed Information</h2>
      <div>
        ${(video.description ||
          `<div class="no-info">
            <span>No video details available.
          </div>`).trim()}
      </div>
    </div>
  `);
}

function open(index, videos, parent) {
  if (!status.onLine) {
    offline_modal.open();
    return Promise.reject();
  }

  let video = videos[index];
  return init().then(() => {
    elem = createElem(video).appendTo(parent);
    player = createPlayer();

    pagination = Pagination({
      prev_title: 'Previous Video',
      next_title: 'Next Video'
    });
    pagination.init({
      container: elem.find('.video-toolbar'),
      total: videos.length,
      current: video.index + 1
    }).on('paginate', (e, index) => setIndex(index - 1));

    sidepanel.open(sidepanelOpt());

    sidepanel.on('closed', close);
    elem.find('.backdrop').click(function(e) {
      if (!$(this).is(e.target)) return;
      sidepanel.close();
      close();
    });

    $(window).on('keydown.video-player', e => {
      if (e.metaKey || e.ctrlKey) return;
      switch (e.keyCode) {
        case 27: sidepanel.close(); break;
        case 37: case 38: prev(); break;
        case 39: case 40: next(); break;
      }
    });
  });

  function next() {
    if (video.index + 1 >= videos.length) return;
    setIndex(video.index + 1);
  }

  function prev() {
    if (video.index - 1 < 0) return;
    setIndex(video.index - 1);
  }

  function setIndex(index) {
    video = videos[index];
    pagination.current = video.index + 1;
    sidepanel.update(sidepanelOpt());

    player.dispose();

    elem.find('#player').remove();
    elem.find('.backdrop').after(playerHtml(video));

    player = createPlayer();
  }

  function createPlayer() {
    return videojs('player', {
      autoplay: true,
      width: Math.min(640, 0.9 * $(parent).width()),
      height: Math.min(480, 0.9 * $(parent).height())
    });
  }

  function sidepanelOpt() {
    return {
      id: 'video_details',
      title: video.caption,
      content: videoDetails(video),
      buttons: [
        {
          icon: fa.fileDownload,
          title: 'Download',
          handler: () => evtbus.trigger('download', [video.url || video.source_url])
        }
      ]
    };
  }
}

function close() {
  $(window).off('keydown.video-player');
  player && player.dispose();
  elem && elem.remove();
  player = null;
  elem = null;
}

api.init = init;
api.open = open;
api.close = close;

module.exports = api;
